import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class AddScriptsService {
    constructor() { }

    public addScripts(portal_settings) {
        try {
            this.addCustomScript(portal_settings);
            this.addCustomScriptWithCookies(portal_settings);
        } catch (error) {
            console.log("Não foi possível executar o script personalizado");
        }
    }

    private addCustomScript(portal_settings) {
        try {
            this.setScript(portal_settings.script_head, 'head');
            this.setScript(portal_settings.script_body, 'body');
        } catch (error) {
            console.log("Não foi possível executar o script personalizado");
        }
    }

    private addCustomScriptWithCookies(portal_settings) {
        if (portal_settings.script_head_with_cookies || portal_settings.script_body_with_cookies) {
            const confirmation = this.getCookieConfirmation();
            if (confirmation === 'accepted') {
                this.setScript(portal_settings.script_head_with_cookies, 'head', false, true);
                this.setScript(portal_settings.script_body_with_cookies, 'body', false, true);
            } else if (confirmation === 'wait') {
                setTimeout(() => {
                    this.addCustomScriptWithCookies(portal_settings);
                }, 1000);
            }
        }
    }

    private getCookieConfirmation() {
        let cookieName = 'rb_lgpd';
        const decodedCookies = decodeURIComponent(document.cookie);
        const splitedCookies = decodedCookies.split('; ');
        let accept = 'wait'
        splitedCookies.forEach((cookie) => {
            const [name, value] = cookie.split('=');
            if (name === cookieName && value === 'true') {
                accept = 'accepted';
            }

            if (name === cookieName && value === 'false') {
                accept = 'declined';
            }

        });
        return accept;
    }

    private setScript(data: string, location, replaceSript: boolean = false, cookies: boolean = false): void {
        let withcookies = "_with_cookies";
        if (replaceSript) {
            this.removeOldScript(location);
        }
        
        if (document.getElementsByClassName(`script_personalizado_${location}${cookies ? withcookies : ""}`).length === 0 && data && data !== '') {
            Array.from(this.createElementFromHTML(data)).forEach(element => {
                if (element.tagName === "SCRIPT" || element.tagName === "NOSCRIPT") {
                    const script = document.createElement(element.tagName);
                    script.innerHTML = String(element.innerHTML);
                    script.classList.add(`script_personalizado_${location}${cookies ? withcookies : ""}`);
                    document[location].appendChild(script);
                }
            });
        }
    }

    private createElementFromHTML(htmlString: string) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.children;
    }

    private removeOldScript($location: string) {
        const elements = document.getElementsByClassName("script_personalizado_" + $location);
        while (elements.length > 0) {
            elements[0].remove();
        }
    }


    public injectGtagDefaultScript(gtag_code) {
        if (document.getElementsByClassName('gtag_integration_script').length === 0) {
            const script = document.createElement('script');
            script.classList.add('gtag_integration_script');
            script.setAttribute('async', 'true');
            script.setAttribute('src', `https://www.googletagmanager.com/gtm.js?id=${gtag_code}`);
            document.head.appendChild(script);

            const noscript = document.createElement('noscript');
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtag_code}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.appendChild(noscript);

            (window as any).dataLayer = (window as any).dataLayer || [];
            (window as any).dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        }
    }
}
